import { Control, Controller, Path } from "react-hook-form";
import { GroupBase } from "react-select";

import { IPipelineStageSelectOption, PipelineStageSelect } from "@components/AddNewEntity";
import { FormLabel } from "@ui/FormElements";

export interface IHasPipelineStageField {
  stage: IPipelineStageSelectOption | null;
}

interface IPipelineStageFormFieldProps<T extends IHasPipelineStageField> {
  control: Control<T>;
  options: GroupBase<IPipelineStageSelectOption>[];
  showGroupHeaders: boolean;
  onSave?: (value: IPipelineStageSelectOption | null) => void;
}

export function PipelineStageFormField<T extends IHasPipelineStageField>({
  control,
  options,
  showGroupHeaders,
  onSave,
}: IPipelineStageFormFieldProps<T>) {
  return (
    <Controller
      control={control}
      name={"stage" as Path<T>}
      render={({ field: { value, onChange } }) => (
        <div className="flex flex-col justify-between gap-0.5">
          <FormLabel htmlFor="stage">Pipeline Stage</FormLabel>
          <div className="w-full">
            <PipelineStageSelect
              options={options}
              value={(value && typeof value === "object") ? value : null}
              onChange={(option) => {
                onChange(option);
                onSave?.(option);
              }}
              showGroupHeaders={showGroupHeaders}
              className="w-full"
            />
          </div>
        </div>
      )}
    />
  );
}
